var $ = require('jquery');
var _ = require('underscore');

var JSContext = require('./jscontext');
var Utils = require('./utils');

var _titleTemplate = '<title><%= title %></title>';
var _metaTagTemplate = '<meta name="<%= name %>" content="<%= content %>" >';

var _getCurrentPageName = function() {
    var slug = JSContext.getSlug();
    var fileName = Utils.getPageName(window.location);
    if(fileName === slug) {
        fileName = "index";
    }
    return fileName;
};

var _makeMetaTag = function(metaTagData){
    var template = _.template(_metaTagTemplate);
    return template(metaTagData);
};

var _makeTitle = function(titleData){
    var template = _.template(_titleTemplate);
    if (titleData.title) {
        document.title = titleData.title;
    }
    return template(titleData);
};

var init = function(seoData){
    var block = "";
    var currentPage = _getCurrentPageName();

    var data = seoData[currentPage] || seoData;

    //If title is provided create title tag
    if(data.title){
        block += _makeTitle(data);
    }

    //If we have meta tags create them all
    if(data.tags && data.tags.length){
        _.each(data.tags, function(e){
            block +=  _makeMetaTag(e);
        });
    }

    $("head").append(block);
};

exports.init = init;



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Lib1ThemeBuild/Platforms/1804Build/~/poly-js-utils/src/seo.js
// module id = 325
// module chunks = 8